import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import { Modal, ModalBody } from 'reactstrap'

const ModalSellerPaymentOnBehalf = ({
  isOpen,
  toggle,
  onConfirm,
  isLoading,
  methods = [],
}) => {
  const methodLabel =
    methods?.map((m) => m.label).filter(Boolean).join(', ') || 'Kredit Penjual'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      data-testid="detail-transaction-modal-payment-on-behalf"
    >
      <ModalBody>
        <P size="medium" className="fw-semibold mb-1">
          Pembayaran Atas Nama Pembeli
        </P>
        <p>
          Apakah Anda yakin ingin melakukan pembayaran atas nama pembeli menggunakan metode <strong>{methodLabel}</strong> untuk melanjutkan transaksi ini?
        </p>
        <div className="d-flex gap-2 justify-content-center mt-4">
          <CustomButton
            onClick={toggle}
            className="btn-cancel"
            outline
            block
            disabled={isLoading}
            testId="detail-transaction-modal-payment-on-behalf-cancel"
          >
            Batal
          </CustomButton>
          <CustomButton
            color="primary"
            block
            onClick={onConfirm}
            disabled={isLoading}
            testId="detail-transaction-button-confirm-payment-on-behalf"
          >
            Lanjut
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalSellerPaymentOnBehalf
